import React, { useEffect, useState } from "react";
import { listCareers, deleteCareer, withBase } from "./api";
import styles from "./List.module.css";

export default function CareersList() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    listCareers()
      .then((res) => setItems(res.items || []))
      .catch((e) => setError(e.message || "Failed to load"));
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div className={styles.title}>Career Jobs</div>
      </div>
      {error && <div className={styles.empty}>{error}</div>}
      <div className={styles.tableWrap}>
        <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th className={styles.th}>#</th>
            <th className={styles.th}>Job Title</th>
            <th className={styles.th}>Description</th>
            <th className={styles.th}>Experience</th>
            <th className={styles.th}>Education Qualification</th>
            <th className={styles.th}>Last Date</th>
            <th className={styles.th}>Email</th>
            <th className={styles.th}>Location</th>
            <th className={styles.th}>Image</th>
            <th className={styles.th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td className={styles.empty} colSpan={10}>No jobs found.</td>
            </tr>
          ) : (
            items.map((it, idx) => (
              <tr key={it.id}>
                <td className={styles.td}>{idx + 1}</td>
                <td className={styles.td}>{it.title}</td>
                <td className={styles.td}>{it.description}</td>
                <td className={styles.td}>{it.year_of_passing}</td>
                <td className={styles.td}>{it.qualification}</td>
                <td className={styles.td}>{it.last_date}</td>
                <td className={styles.td}>{it.contact_email}</td>
                <td className={styles.td}>{it.office_location}</td>
                <td className={styles.td}>{it.logo_path ? (<div style={{width: '80px', height: '60px', borderRadius: '6px', overflow: 'hidden', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center'}}><img className={styles.img} src={withBase(it.logo_path)} alt="logo" /></div>) : <span style={{color: '#999'}}>No image</span>}</td>
                <td className={styles.td}>
                  <div className={styles.actions}>
                    <button className={`${styles.btn} ${styles.btnEdit}`} onClick={()=>{
                      const params = new URLSearchParams({ id: String(it.id) });
                      window.location.href = `/admin/careers/add?${params.toString()}`;
                    }}>Edit</button>
                    <button className={`${styles.btn} ${styles.btnDelete}`} disabled={busyId===it.id} onClick={async()=>{
                      setBusyId(it.id);
                      try { await deleteCareer(it.id); setItems(items.filter(x=>x.id!==it.id)); }
                      catch(e){ setError(e.message||'Delete failed'); }
                      finally{ setBusyId(null); }
                    }}>Delete</button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
}


